import React, { useState } from "react";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { Input } from "antd";
import Style from "./chargewallet.module.css";
import { separate } from "../../Seprate/Seprate";
import { errorToast, succToast } from "../../Toast/Toast";
import { chargeWalletAPI } from "../../Api/BarestServices";
const Chargewallet = () => {
  const [amountSate, setAmountState] = useState();
  const [loadigState, setLoadingState] = useState(false);
  const chargeHandler = () => {
    if (!amountSate) {
      errorToast("مبلغ را وارد کنید!");
      return;
    }
    setLoadingState(true);
    let info = {
      amount: amountSate,
      payment_type: "pgw",
    };
    chargeWalletAPI(info, (res) => {
      if (res.status === 1) {
        setLoadingState(false);
        succToast("تا لحاظتی دیگر وارد صفحه پرداخت میشید!");
        setTimeout(() => {
          window.open(res.link, "_self");
        }, 1000);
      } else {
        errorToast(res.message);
        setLoadingState(false);
      }
    });
  };
  return (
    <div>
      <BurgerMenuTitle title={" شارژ کیف پول"} />
      <section className={Style.contentHolder}>
        <img src="/Assets/Images/Menu/transformMoney.svg" alt="" />
        <div className={Style.FormHolder}>
          <label htmlFor="">شارژ حساب به مبلغ:</label>
          <Input
            type="number"
            placeholder="مبلغ را به تومان وارد کنید"
            value={amountSate}
            onChange={(e) => setAmountState(e.target.value)}
          />
          {amountSate && (
            <p style={{ color: "green" }}>{separate(amountSate)} تومان</p>
          )}
          <button
            className={Style.ButtonHolder}
            onClick={chargeHandler}
            disabled={loadigState}
          >
            {loadigState ? "منتظر بمانید..." : "پرداخت"}
          </button>
        </div>
      </section>
    </div>
  );
};

export default Chargewallet;
